export { State, Getter, Action, Mutation, namespace } from './bindings';



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuex-class/lib/index.js
// module id = ./node_modules/vuex-class/lib/index.js
// module chunks = 0 2 3 4 5